import React, { Component } from 'react';
import {TweenMax, TimelineMax} from 'gsap';
import PropTypes from 'prop-types';
import fa from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SolidIcons from '@fortawesome/fontawesome-free-solid'

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    fa.library.add(SolidIcons);
    this.setHref()
  }

  componentWillUnmount() {
  }

  getIcon = () => {
    return fa.findIconDefinition({iconName: this.props.icon})
  }

  setHref = () => {
    if (this.props.link) {
      this.Button.href = this.props.link;
    }
  }

  getClassname() {
    let classname = '';
    classname = this.props.dark ? "dark" : classname
    classname = this.props.onWhite ? "on-white" : classname
    return classname
  }

  render() {
    return (
      <a className="Button-container" ref={el => this.Button = el}
         onClick={()=>{
           if (typeof this.props.action == "function") {
             this.props.action(event);
           }
          }}>
        <div className={`Button ${this.getClassname()}`} style={this.props.style || {}} >
          { this.props.icon &&
            <div className={"button-icon" + (this.props.mirrored ? " mirrored" : "")}>
              <FontAwesomeIcon icon={this.getIcon()} />
            </div>
          }
          {this.props.title}
        </div>
      </a>
    );
  }
}

Button.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  dark: PropTypes.bool,
  link: PropTypes.string,
  action: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/Button/Button.js